import Scene from '../../classes/scene';
import Utils from '../../classes/utils';

export default class SceneInterfaceDemo extends Scene {
		
	constructor(args) {
		super(args);
		this.pointer = true;
	}

	init(data) {
		super.init(data);

		let scr = this.system.screen;
		let pal = this.system.palette;
		let f = this.system.factory;

		this.system.display.settings.lfoMult = 11.73;

		f.text({
			x:'50%', y:'50%', scale:2.5,
			text:'hello :)',
			color: pal.blue,
		});

		f.button({
			x:'100% -50', y:50, scale: 1,
			text:'exit',
			align:'right',
			color: pal.red,
			onClick: () => {
				this.system.sceneManager.changeScene('sceneExample');
				this.system.audio.playSample('gui_tiny');
				this.system.audio.stopMusic();
			}
		});

		this.smallText = null;

		// user interface demo
		this.uiManager.showPopup({
			name:'one',
			color:'white',
			transparent:true, // objects underneath and beside this popup will still be clickable
			width:512,
			items:[
				{
					type:'text', scale:2.5, color:'green',
					text:'giant text',
				},
				{
					type:'text', scale:1.5, color:'green',
					text:'medium text',
				},
				{
					type:'text', scale:0.75, color:'green',
					text:'small text',
				},
				{
					type:'divider',
				},
				{
					type:'text', scale:1.5,
					text:`here's another section`,
				},
				{
					type:'space',
				},
				{
					type:'switch', color:'blue',
					text:'button is blue ^',
					initial:'blue',
					states: [
						'magenta',
						'blue',
						'yellow',
						'green',
						'red',
					],
					onSet: this.colorSwitch.bind(this),
				},
				{
					type:'text', scale:1, color:'blue',
					text:'click to change color',
					height:45,
					ref:'smallText',
				},
				{
					type:'space',
				},
				{
					type:'button',
					text:'a disabled button',
					disabled:true,
					onClick:() => {
						log('you clicked something!');
					},
				},
				{
					type:'divider',
					height:60,
				},
				{
					type:'button',
					text:'open another popup',
					onClick:() => {
						this.system.audio.playSample('gui_tiny');
						this.openSecondPopup();
					},
				},
				{
					type:'button', color:'red',
					text:'close',
					onClick:() => {
						this.uiManager.closePopup('one');
						this.system.audio.playSample('gui_confirm');
					},
				},
			],
		});
	}

	// e = the switch ui entity, v = the new value
	colorSwitch(e, v) {
		e.brain.updateText(`button is ${v} ^`);
		e.sprite.color = e.sprite.baseColor = this.smallText.sprite.color = this.system.palette[v];
		this.system.audio.playSample('gui_select');
	}

	openSecondPopup() {
		this.uiManager.showPopup({
			name:'two',
			color:'blue',
			width:480,
			items:[
				{
					type:'text', scale:1.5,
					text:'secondary popup',
				},
				{
					type:'divider',
				},
				{
					type:'button',
					text:'open another one!',
					onClick:() => {
						this.system.audio.playSample('gui_tiny');
						this.openThirdPopup();
					},
				},
				{
					type:'text', scale:1, color:'white',
					text:`here's an example of a paragraph\nof text spanning multiple lines\nusing the old backslash-n unix\ncharacter thingy for 'newline'`,
				},
				{
					type:'button', color:'red',
					text:'close this popup',
					onClick:() => {
						this.uiManager.closePopup('two');
						this.system.audio.playSample('gui_confirm');
					},
				},
			],
		});
	}

	openThirdPopup() {
		this.layers.interface.easeCamera({scale:2}, 1000);
		this.uiManager.showPopup({
			name:'three',
			color:'yellow',
			width:320,
			items:[
				{
					type:'text', scale:1.25,
					text:'this is the end',
				},
				{
					type:'divider',
				},
				{
					type:'button',
					text:'oh, ok',
					onClick:() => {
						this.uiManager.closePopup('three');
						this.system.audio.playSample('gui_confirm');
						this.layers.interface.easeCamera({scale:1}, 250);
					},
				},
			],
		});
	}

}